import styles from 'assets/css/StatusMessage.module.css';
import classNames from 'classnames';

export const STATUS_STATE = {
    INFO: 'Info',
    WARN: 'Warn',
    ALERT: 'Alert',
    NONE: null
};

export const statusMessageHelpers = {
    getStatusStateTextClass: (statusState) => classNames({ [`${styles[`status${statusState}`]}`]: statusState }),
    getStatusStateSVGClass: (statusState) => classNames({ [`${styles[`status${statusState}--svg`]}`]: statusState }),
    getStatusStateBackgroundClass: (statusState) => classNames({ [`${styles[`status${statusState}--bg`]}`]: statusState }),
    getStatusStateBorderClass: (statusState) => classNames({ [`${styles[`status${statusState}--border`]}`]: statusState }),
    getStatusStateColor: (statusState) => {
        switch (statusState) {
            case STATUS_STATE.INFO:
                return '#4abfad';
            case STATUS_STATE.WARN:
                return '#f2b645';
            case STATUS_STATE.ALERT:
                return '#e53d46';
            case STATUS_STATE.NONE:
            default:
                return null;
        }
    }
};